/* index.tsx generated by @compiled/babel-plugin v0.36.1 */
import _extends from "@babel/runtime/helpers/extends";
import "./index.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { fg } from '@atlaskit/platform-feature-flags';
import FlexibleCard from '../../../FlexibleCard';
import { CustomBlock, InternalFooterBlock, PreviewBlock, TitleBlock } from '../../../FlexibleCard/components/blocks';
import { FlexibleCardUiOptions, PreviewBlockOptions, titleBlockOptions } from '../utils';
import UnresolvedViewOld from './UnresolvedViewOld';
var customBlockStyles = null;
var titleBlockCss = null;
var footerBlockCss = null;
var UnresolvedView = function UnresolvedView(_ref) {
  var actions = _ref.actions,
    cardState = _ref.cardState,
    children = _ref.children,
    onAuthorize = _ref.onAuthorize,
    onClick = _ref.onClick,
    onError = _ref.onError,
    _ref$showPreview = _ref.showPreview,
    showPreview = _ref$showPreview === void 0 ? false : _ref$showPreview,
    testId = _ref.testId,
    title = _ref.title,
    url = _ref.url;
  return /*#__PURE__*/React.createElement(FlexibleCard, {
    appearance: "block",
    cardState: cardState,
    onAuthorize: onAuthorize,
    onClick: onClick,
    onError: onError,
    origin: "smartLinkCard",
    testId: testId,
    ui: FlexibleCardUiOptions,
    url: url
  }, /*#__PURE__*/React.createElement(TitleBlock, _extends({}, titleBlockOptions, {
    hideIcon: !!title,
    text: title,
    status: cardState.status,
    className: ax(["_zulp1f3t _13mh1pd9"])
  })), /*#__PURE__*/React.createElement(CustomBlock, {
    status: cardState.status,
    className: ax(["_4cvr1y6m"])
  }, children), showPreview && /*#__PURE__*/React.createElement(PreviewBlock, _extends({}, PreviewBlockOptions, {
    status: cardState.status
  })), /*#__PURE__*/React.createElement(InternalFooterBlock, {
    actions: actions,
    testId: "smart-block-card-footer",
    status: cardState.status,
    className: ax(["_4t3i1k8s _g0eioxwj _1qryoxwj _sxbroxwj _1gyioxwj"])
  }));
};
export var UnresolvedViewExported = function UnresolvedViewExported(props) {
  if (fg('bandicoots-compiled-migration-smartcard')) {
    return /*#__PURE__*/React.createElement(UnresolvedView, props);
  } else {
    return /*#__PURE__*/React.createElement(UnresolvedViewOld, props);
  }
};
export default UnresolvedViewExported;